import type { ReplacementImpact } from '~/pages/backoffice/admin/modules/replacement-impact'
import { useTranslation } from 'react-i18next'
import FormWarning from '~/components/FormWarning'

/**
 * Ce que la nouvelle version change, dit avant la bascule (#311) : les parcours
 * touchés, ce qui arrive aux apprenants selon où ils en sont, et les chapitres.
 */
function ReplacementImpactSummary({ impact }: { impact: ReplacementImpact }) {
  const { t } = useTranslation()
  const { sessionNames, completedLearners, inProgressLearners, notStartedLearners, keptScos, addedScos, removedScos } = impact

  return (
    <div className="flex flex-col gap-3 text-sm">
      <p>
        {sessionNames.length > 0
          ? t('modules.replace.sessions', { count: sessionNames.length, names: sessionNames.join(', ') })
          : t('modules.replace.noSession')}
      </p>
      <ul className="flex list-disc flex-col gap-1 pl-5">
        <li>{t('modules.replace.completed', { count: completedLearners })}</li>
        <li>{t('modules.replace.inProgress', { count: inProgressLearners })}</li>
        <li>{t('modules.replace.notStarted', { count: notStartedLearners })}</li>
      </ul>
      {(addedScos.length > 0 || removedScos.length > 0) && (
        <p className="text-muted-foreground">
          {t('modules.replace.scos', { kept: keptScos.length, added: addedScos.length, removed: removedScos.length })}
        </p>
      )}
      {impact.noScoMatch && (
        <FormWarning>{t('modules.replace.noScoMatch', { count: inProgressLearners })}</FormWarning>
      )}
    </div>
  )
}

export default ReplacementImpactSummary
